import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { createCategory } from "@/lib/admin.functions";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { PageHeader, Field, inp, slugify } from "@/components/admin/shared";

export const Route = createFileRoute("/admin/categories/new")({
  component: NewCategoryPage,
});

function NewCategoryPage() {
  const create = useServerFn(createCategory);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    slug: "",
    name: "",
    description: "",
    sort_order: 0,
    is_published: true,
  });
  const [busy, setBusy] = useState(false);

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await create({
        data: { ...form, description: form.description || null },
      });
      toast.success("Kategori skapad");
      navigate({ to: "/admin/categories" });
    } catch (e: any) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHeader title="Ny kategori" backTo="/admin/categories" />
      <form
        onSubmit={save}
        className="rounded-2xl border border-border bg-card p-6 grid sm:grid-cols-2 gap-4"
      >
        <Field label="Namn *">
          <input
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className={inp}
            required
          />
        </Field>
        <Field label="Slug *">
          <div className="flex gap-2">
            <input
              value={form.slug}
              onChange={(e) => setForm({ ...form, slug: e.target.value })}
              className={inp}
              required
              placeholder="ny-kategori"
            />
            <button
              type="button"
              onClick={() => setForm({ ...form, slug: slugify(form.name) })}
              className="rounded-lg bg-secondary px-3 text-xs whitespace-nowrap"
            >
              Auto
            </button>
          </div>
        </Field>
        <Field label="Beskrivning" full>
          <textarea
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            className={`${inp} min-h-[80px]`}
          />
        </Field>
        <Field label="Sortering">
          <input
            type="number"
            value={form.sort_order}
            onChange={(e) =>
              setForm({ ...form, sort_order: parseInt(e.target.value) || 0 })
            }
            className={inp}
          />
        </Field>
        <label className="flex items-center gap-2 text-sm self-end pb-2">
          <input
            type="checkbox"
            checked={form.is_published}
            onChange={(e) => setForm({ ...form, is_published: e.target.checked })}
          />{" "}
          Publicerad
        </label>
        <div className="sm:col-span-2 flex justify-end">
          <button
            type="submit"
            disabled={busy}
            className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-2.5 text-sm font-bold disabled:opacity-50"
          >
            {busy ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Save className="h-4 w-4" />
            )}{" "}
            Skapa
          </button>
        </div>
      </form>
    </>
  );
}
